import { render, staticRenderFns } from "./NewLoginView.vue?vue&type=template&id=20ac5a16&scoped=true&"
import script from "./NewLoginView.vue?vue&type=script&lang=js&"
export * from "./NewLoginView.vue?vue&type=script&lang=js&"
import style0 from "./NewLoginView.vue?vue&type=style&index=0&id=20ac5a16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ac5a16",
  null
  
)

export default component.exports